import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import moment from "moment";

export default class PrintMeetingDayCards extends React.Component {
  render() {
    const dateArr = this.props.dateArr;
    return (
      <div>
        <h2>{this.props.date}</h2>
        <hr className="mt-3 mb-3" />
        {dateArr.map((a) => (
          <Card className="my-2" style={{}} key={a.timeSlotStart.toString()}>
            <CardHeader>
              {moment(a.timeSlotStart).format("MMMM Do YYYY, h:mm a")}
            </CardHeader>
            <CardBody>
              <CardTitle tag="h5">
                <span className="float-left">
                  Litigant: {a.litigantFirstName} {a.litigantLastName}
                </span>
                <span className="float-right">
                  Attorney: {a.attorneyFirstName} {a.attorneyLastName}
                </span>
              </CardTitle>
              <br />
              <hr />
              <br />
              <CardText>
                {a.questionAndAnswers.map((qad, index) => (
                  <React.Fragment key={index}>
                    <span className="mt-10 mb-10 font-weight-bold">
                      {qad.question}
                    </span>
                    <br />
                    <span className="mt-10 mb-10">&ensp;{qad.answer}</span>
                    <br />
                  </React.Fragment>
                ))}
              </CardText>
            </CardBody>
          </Card>
        ))}
      </div>
    );
  }
}
